import * as constants from "./constants";
import electricApi from "@/api/electric";


export const changeElectric = (data,type) => {
    return {
        type: type,
        data
    };
};

//数据列表
export const getLogList = (data) => {
    return (dispatch) => {
        electricApi.getLogList(data)
            .then(res => {
                if(res) {
                    dispatch(changeElectric(res,constants.AISLE_LOG));
                }
            })
    };
};


